class UserAccessReportController {
    constructor($browser, toastr, $window, moment, UserDetailsApi, SettingsService, $location, ngProgressFactory, ReportServiceApi, ReportUtilityServiceApi, ReportUtils) {
        this.$onInit = () => {
            this.state = {
                userDetails: null,
                reportRequest: {},
                gridOptions: {},
                DateFormats: {},
                selectedUser: { Id: 0, Name: 'Loading...' },
                selectedFromDate: {},
                selectedToDate: {},
                clear: true,
                allowGlobalSearch: false,
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                showReport: false,
                loading: true
            };
            this.data = {
                userAccessReports: [],
                users: []
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.userAccessReport = {
                Id: 0,
                Name: '',
                Description: 'User Access Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.datePicker = {
                date: { startDate: null, endDate: null },
                options: {
                    showCustomRangeLabel: false,
                    alwaysShowCalendars: true
                }
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.columnDefs = [
                {
                    headerName: 'UserId',
                    field: 'UserId',
                    width: 70,
                    minWidth: 90,
                    resizable: true,
                    hide: true,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'User',
                    field: 'DisplayName',
                    minWidth: 100,
                    resizable: true,
                    suppressSizeToFit: false
                },
                {
                    headerName: 'Login Time (UTC)',
                    field: 'LoggedIn',
                    width: 175,
                    minWidth: 175,
                    cellRenderer: this.loginTimeCellRenderer,
                    suppressSizeToFit: true,
                    sort: 'desc'
                },
                {
                    headerName: 'Logout Time (UTC)',
                    field: 'LoggedOut',
                    width: 175,
                    minWidth: 175,
                    cellRenderer: this.logoutTimeCellRenderer,
                    suppressSizeToFit: true
                },
                {
                    headerName: 'Exit Method',
                    field: 'ExitMethod',
                    minWidth: 130,
                    resizable: true,
                    suppressSizeToFit: false
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.rowCount = '0';
            this.traceProgress.start();
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.showReport = true;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.datePicker.options = {
                    showCustomRangeLabel: false,
                    alwaysShowCalendars: true,
                    format: this.state.DateFormats.DateFormat,
                    locale: {
                        cancelLabel: 'Cancel'
                    },
                    maxDate: this.moment(),
                    separator: ' to ',
                    eventHandlers: {
                        'apply.daterangepicker': () => {
                            this.selectDateRange();
                        },
                        'cancel.daterangepicker': () => {
                            this.clearDates();
                        }
                    },
                    ranges: {
                        Today: [this.moment(), this.moment()],
                        Yesterday: [
                            this.moment().subtract(1, 'days'),
                            this.moment().subtract(1, 'days')
                        ],
                        'Last 7 Days': [
                            this.moment().subtract(6, 'days'),
                            this.moment()
                        ],
                        'Last 30 Days': [
                            this.moment().subtract(29, 'days'),
                            this.moment()
                        ],
                        'This Month': [
                            this.moment().startOf('month'),
                            this.moment().endOf('month')
                        ],
                        'Last Month': [
                            this.moment()
                                .subtract(1, 'month')
                                .startOf('month'),
                            this.moment()
                                .subtract(1, 'month')
                                .endOf('month')
                        ],
                        'Last 3 Months': [
                            this.moment()
                                .subtract(3, 'month')
                                .startOf('month'),
                            this.moment()
                                .endOf('month')
                        ]
                    }
                };
            });
            this.UserDetailsApi.get().then((response) => {
                this.state.userDetails = response.data; // setup our user details
                this.state.selectedFromDate = null;
                this.state.selectedToDate = null;
                let req = {
                    UserId: this.state.selectedUser.Id,
                    FromDate: this.state.selectedFromDate,
                    ToDate: this.state.selectedToDate
                };
                this.ReportServiceApi.getUserAccessReport(req).then((response) => {
                    this.traceProgress.complete();
                    this.data.userAccessReports = response.data;
                    // Create a list of users and select the first one
                    this.data.users = this.users(this.data.userAccessReports) || { Id: 0, Name: 'No users available' };
                    this.state.selectedUser = this.data.users[0];
                    this.selectUser(this.data.users[0], false);
                    this.state.loading = false;
                    return;
                });
            }, () => {
                this.traceProgress.complete();
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href =
                    this.browser.baseHref() + 'account/login';
                return;
            });
            this.ReportServiceApi.getReportByName('UserAccessReport').then((response) => {
                if (Object.keys(response.data).length > 0) {
                    this.userAccessReport = response.data;
                }
                else {
                    this.toastr.warning('Report descriptions not found');
                }
            });
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.users = (userAccessReports) => {
            let users = _.map(userAccessReports, (item) => {
                return {
                    Id: item.UserId,
                    Name: item.DisplayName
                };
            });
            // @ts-ignore lodash
            let uniqueUsers = _.uniqBy(users, (item) => {
                return item.Id;
            });
            if (uniqueUsers.length === 0) {
                return [{ Id: 0, Name: 'No Users available' }];
            }
            const sorted = _.sortBy(uniqueUsers, ['Name']);
            const first = { Id: 0, Name: 'Select a user' };
            // @ts-ignore lodash
            return _.concat(first, sorted);
        };
        this.loginTimeCellRenderer = (row) => {
            let rowData = row.data;
            return this.timeCellRenderer(rowData.LoggedIn);
        };
        this.logoutTimeCellRenderer = (row) => {
            let rowData = row.data;
            return this.timeCellRenderer(rowData.LoggedOut);
        };
        this.timeCellRenderer = (date) => {
            // Check if the contents are empty, if so then dont do anything
            // @ts-ignore
            if (_.isNil(date)) {
                return '<span></span>';
            }
            // Add a Z to indicate this is a UTC time
            const time = [
                '<span>',
                this.moment(date + 'Z')
                    .utc()
                    .format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            return time;
        };
        this.onModelUpdated = () => {
            const model = this.gridOptions.api.getModel();
            const processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
        };
        this.selectUser = (user, autoLoad) => {
            let load = autoLoad || false;
            // console.debug('selectUser');
            // console.debug(user);
            this.state.selectedUser = user;
            this.state.loading = false;
            // Clear the filter boxes and set their max and min dates back up.
            if (this.state.clear === true) {
                this.clearDates();
            }
            if (this.data.users === undefined || this.data.users[1] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedUser = this.data.users[0];
            if (user !== undefined ||
                (user !== null &&
                    Object.prototype.toString.call(user) === '[object Object]')) {
                this.state.selectedUser = user;
            }
            if (load) {
                // If we have a valid user
                if (this.state.selectedUser.Id > 0) {
                    this.updateTable();
                }
                else {
                    // If we don't have a valid user
                    this.gridOptions.api.setRowData(null);
                }
            }
        };
        this.exportCsv = () => {
            let Description = this.state.selectedUser.Name;
            let title = [Description, '-' + this.userAccessReport.Description + '.csv'].join('');
            let reportName = this.ReportService.addDateToTitle(title);
            let params = {
                allColumns: false,
                fileName: reportName,
                processCellCallback: (params) => {
                    return params.value;
                }
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.selectDateRange = () => {
            this.state.selectedFromDate = this.moment(this.datePicker.date.startDate)
                .utc().toDate();
            this.state.selectedToDate = this.moment(this.datePicker.date.endDate)
                .utc().toDate();
            if (this.state.selectedUser.Id > 0) {
                this.updateTable();
            }
        };
        this.clearDates = () => {
            this.datePicker.date = { startDate: null, endDate: null };
            this.state.selectedFromDate = this.datePicker.date.startDate;
            this.state.selectedToDate = this.datePicker.date.endDate;
            if (angular.isUndefined(this.state.selectedUser)) {
                return;
            }
            if (this.state.selectedUser.Id > 0) {
                this.updateTable();
            }
        };
        this.updateTable = () => {
            this.gridOptions.api.showLoadingOverlay();
            let req = {
                UserId: this.state.selectedUser.Id,
                FromDate: this.state.selectedFromDate,
                ToDate: this.state.selectedToDate
            };
            this.state.loading = true;
            this.ReportServiceApi.getUserAccessReport(req).then((response) => {
                this.data.userAccessReports = response.data;
                this.gridOptions.api.setRowData(this.data.userAccessReports);
                this.state.loading = false;
                return;
            });
        };
        this.browser = $browser;
        this.toastr = toastr;
        this.window = $window;
        this.moment = moment;
        this.UserDetailsApi = UserDetailsApi;
        this.SettingsService = SettingsService;
        this.location = $location;
        this.ngProgressFactory = ngProgressFactory;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportService = ReportUtilityServiceApi;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('userAccessReport', {
    templateUrl: 'Scripts/App/partials/Reports/user-access-report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: UserAccessReportController
});
